<template>
  <div class="suara-penentu-widget">
    <div class="info">
      <div class="info-wrapper">
        <ImageResponsive imageUrl="suara-penentu/logo_white.svg" class="logo" />
        <span class="desc"
          >Telusuri profil, rekam jejak, hingga aktivitas kampanye
          capres-cawapres dan caleg pilihanmu.</span
        >
        <Link class="action" to="/suarapenentu"
          ><span>Selengkapnya</span>
          <ImageResponsive imageUrl="suara-penentu/arrow.svg" class="arrow" />
        </Link>
      </div>
    </div>
    <div class="articles">
      <div class="position-relative">
        <div v-swiper:mySwiperSuaraPenentu="swiperOption">
          <div class="swiper-wrapper">
            <nuxt-link
              :to="highlight.slug"
              class="swiper-slide"
              v-for="(highlight, index) in this.$store.state.suaraPenentu
                .highlights.items"
              :key="`suara-penentu-index-${index}`"
            >
              <ImageResponsiveSquare
                :imageUrl="highlight.thumbnail"
                :fromUrl="true"
                width="184"
                height="103"
                widthMobile="138"
                heightMobile="77"
                gravity="no"
                class="article-img-suara-penentu"
              />
              <div class="title">{{ highlight.title }}</div>
            </nuxt-link>
          </div>
        </div>
        <div class="shadow-arrow shadow-left prev-suara-penentu">
          <div class="icon-wrapper">
            <Icons name="arrow-left" color="#564480" class="arrow prev" />
          </div>
        </div>
        <div class="shadow-arrow shadow-right next-suara-penentu">
          <div class="icon-wrapper">
            <Icons name="arrow-right" color="#564480" class="arrow next" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageResponsive from "@/components/ImageResponsive";
import ImageResponsiveSquare from "@/components/ImageResponsiveSquare";
import Icons from "@/components/Icons";
import Link from "@/components/Link";

export default {
  components: {
    ImageResponsive,
    Icons,
    Link,
    ImageResponsiveSquare,
  },
  data() {
    return {
      swiperOption: {
        freeMode: false,
        autoHeight: true,
        calculateHeight: true,
        pagination: false,
        autoplay: false,
        navigation: {
          prevEl: ".prev-suara-penentu",
          nextEl: ".next-suara-penentu",
        },
        breakpoints: {
          820: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          1023: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
          320: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
        },
      },
    };
  },
  mounted() {
    this.$store.dispatch("suaraPenentu/getArticlesByTags", {
      tagsSlug: "suara-penentu,suara-penentu-pinned",
      page: 1,
      limit: 5,
    });
  },
};
</script>

<style lang="scss" scoped>
.suara-penentu-widget {
  background-image: url(../static/storage/images/suara-penentu/bg_widget.svg);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 24px;
  border-radius: 4px;
  display: flex;

  @media only screen and (max-width: 1024px) {
    padding: 16px;
    position: relative;
  }

  .info {
    width: 25%;
    display: flex;
    gap: 20px;
    padding-right: 16px;
    border-right: 1px solid #70648d;

    @media only screen and (max-width: 1024px) {
      width: 40%;
      padding-right: 8px;
      gap: 0;
      display: block;
    }

    @media screen and (min-device-width: 820px) and (max-device-width: 1024px) {
      width: 45%;
    }

    .info-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;

      @media only screen and (max-width: 1024px) {
        width: 100%;
        padding-right: 12px;
      }
      .logo {
        width: 54px;
        height: auto;
        @media only screen and (max-width: 1024px) {
          margin-top: -4px;
        }
      }

      .desc {
        font-family: "Varela Round";
        font-size: 13px;
        color: #fff;

        @media only screen and (max-width: 1024px) {
          font-size: 11px;
          margin-top: 0;
        }
      }

      .action {
        display: flex;
        gap: 4px;
        align-items: center;
        background-color: #ffb400;
        padding: 8px 12px;
        width: fit-content;
        border-radius: 4px;
        color: #0c0b0d;
        font-size: 13px;

        @media only screen and (max-width: 1024px) {
          padding: 6px 12px;
          font-size: 12px;
        }

        .arrow {
          width: 16px;
          height: 16px;
        }
      }
    }

    .chat-wrapper {
      width: 60%;
      display: flex;
      gap: 16px;
      flex-direction: column;
      .countdown {
        background: url(../static/storage/images/suara-penentu/bg_countdown.svg)
          no-repeat;
        background-size: cover;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        align-items: center;
        gap: 8px;

        @media only screen and (max-width: 1024px) {
          position: absolute;
          top: 0;
          right: 0;
          width: 75%;
          border-radius: 0px 4px 0px 4px;
          padding: 5px 8px;
          justify-content: space-between;
        }

        @media screen and (min-device-width: 820px) and (max-device-width: 1024px) {
          width: fit-content;
        }

        .live-icon-wrapper {
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 16px;
          height: 16px;
          font-size: 14px;
          border-radius: 100%;

          .live-icon {
            width: 14px;
            height: 14px;
            border-radius: 100%;
            background: #db001e;
            line-height: 0;
            -webkit-animation: breathing 1s ease-out infinite normal;
            animation: breathing 1s ease-out infinite normal;

            @keyframes breathing {
              0% {
                -webkit-transform: scale(0.8);
                -ms-transform: scale(0.8);
                transform: scale(0.8);
              }

              25% {
                -webkit-transform: scale(1);
                -ms-transform: scale(1);
                transform: scale(1);
              }

              60% {
                -webkit-transform: scale(0.8);
                -ms-transform: scale(0.8);
                transform: scale(0.8);
              }

              100% {
                -webkit-transform: scale(0.8);
                -ms-transform: scale(0.8);
                transform: scale(0.8);
              }
            }
          }
        }

        .wording {
          font-size: 10px;
          color: #564480;
          font-family: Varela Round;

          @media only screen and (max-width: 1024px) {
            font-size: 8px;
          }
        }

        .action {
          @media only screen and (max-width: 1024px) {
            margin-left: 51px;
          }
        }

        .arrow {
          width: 16px;
          height: 16px;
        }

        .countdown-item {
          text-align: center;
          text-wrap: nowrap;

          @media only screen and (max-width: 1024px) {
            border-radius: 8px;
            text-align: left;
          }

          .countdown-wrapper {
            @media only screen and (max-width: 1024px) {
              display: flex;
              align-items: center;
            }

            .countdown-info {
              font-size: 12px;
              color: red;

              @media only screen and (max-width: 1024px) {
                padding-top: 0;
                font-size: 10px;
                flex-wrap: wrap-reverse;
                margin-left: 4px;
              }
            }

            .countdown-day {
              width: 18.5px;
              height: 20.5px;
              display: inline-table;
              background: #fff;
              margin: 0 2px;
              border-radius: 3.375px;
              box-shadow: 0px 2.7px 4.725px 0px rgba(0, 0, 0, 0.25);

              @media only screen and (max-width: 1024px) {
                text-align: center;
              }

              .countdown-day-item {
                display: inline;
                font-size: 12px;
                font-family: "Roboto", sans-serif;
                font-weight: 700;
              }
            }
          }
        }
      }

      .chatbot {
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.2);
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;

        @media only screen and (max-width: 1024px) {
          position: absolute;
          left: 16px;
          width: 47%;
          top: 40px;
          background: rgba(255, 255, 255, 0.3);
        }

        .animation {
          @media only screen and (max-width: 1024px) {
            width: 48px;
            height: 100%;
          }
        }

        .caption {
          font-family: Varela Round;
          font-size: 13px;
          color: #fff;

          @media only screen and (max-width: 1024px) {
            font-size: 12px;
            display: none;
          }

          &.mobile {
            display: none;

            @media only screen and (max-width: 1024px) {
              display: block;
            }
          }
        }
      }
    }
  }

  .articles {
    width: 75%;
    padding-left: 16px;

    @media only screen and (max-width: 1024px) {
      width: 60%;
      padding-left: 8px;
      margin-top: 24px;
    }

    @media screen and (min-device-width: 820px) and (max-device-width: 1024px) {
      width: 55%;
    }

    .position-relative {
      .swiper-wrapper {
        .swiper-slide {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .article-img-suara-penentu {
            height: 103px;

            @media only screen and (max-width: 1024px) {
              height: 77px;
            }

            ::v-deep img {
              object-fit: cover;
              border-radius: 4px;
            }
          }

          .title {
            font-family: "Varela Round", sans-serif;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            color: #fff;

            @media only screen and (max-width: 1024px) {
              font-size: 12px;
            }
          }
        }
      }
    }

    .shadow-arrow {
      pointer-events: none;
      position: absolute;
      width: 35px;
      height: 35px;
      border-radius: 100%;
      padding: 0;
      background: rgb(0, 0, 0);
      z-index: 2;
      opacity: 1;
      top: 50%;
      transform: translateY(-50%);
      transition: ease-in-out 0.5s;

      @media only screen and (max-width: 1024px) {
        display: none;
      }

      .icon-wrapper {
        width: 35px;
        height: 35px;
        transform: translateY(-50%);
        top: 50%;
        position: absolute;
        border-radius: 100%;

        svg {
          pointer-events: visible;
          width: 100%;
          height: 100%;
        }
      }

      &.shadow-left {
        left: 0;
        background: #fff;
      }

      &.shadow-right {
        right: 0;
        background: #fff;
      }

      &.swiper-button-disabled {
        opacity: 0;
        z-index: 0;
      }
    }

    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      width: auto;

      @media only screen and (max-width: 1024px) {
        display: none;
      }

      &.prev {
        left: 0;
      }

      &.next {
        right: 0;
      }

      &.hide {
        display: none;
      }
    }
  }
}
</style>
